$(window).on('load', () => {
  const map = document.querySelector('.contact__map');
  if (map) {
    new_map($(map));
  }
  const current_date = new Date();
  const cmm = current_date.getFullYear();
  $('.footer__info__col span').html(cmm);

  const owl = $('.home__slider');
  owl.owlCarousel({
    loop: true,
    margin: 0,
    nav: false,
    items: 1,
    autoplay: true,
    autoplayTimeout: 3000
  });
  $('.home__slider__nav--left').on('click', function() {
    owl.trigger('prev.owl.carousel');
  });
  $('.home__slider__nav--right').on('click', function() {
    owl.trigger('next.owl.carousel');
  });

  // portfolio filter
  const filterButton = document.querySelector('.portfolio__filters');
  if (filterButton) {
    var $grid = $('.portfolio').isotope({
      itemSelector: '.portfolio__item '
    });
    $grid.on('arrangeComplete', function() {
      AOS.refresh();
    });
  }

  const hamburger = document.querySelector('.hamburger');
  if (hamburger) {
    hamburger.addEventListener('click', function() {
      document
        .querySelector('.header__nav__container')
        .classList.toggle('show');
      this.classList.toggle('show');
      document.querySelector('body').classList.toggle('navShowe');
    });
  }
  // filter functions
  var filterFns = {
    // show if number is greater than 50
    numberGreaterThan50: function() {
      var number = $(this)
        .find('.number')
        .text();
      return parseInt(number, 10) > 50;
    },
    // show if name ends with -ium
    ium: function() {
      var name = $(this)
        .find('.name')
        .text();
      return name.match(/ium$/);
    }
  };

  // bind filter button click
  $('.portfolio__filters').on('click', 'div', function() {
    $('.portfolio__filters div').removeClass('active');
    $(this).addClass('active');
    var filterValue = $(this).attr('data-filter');
    // use filterFn if matches value
    filterValue = filterFns[filterValue] || filterValue;
    $grid.isotope({ filter: filterValue });
  });

  const owlAbout = $('.about__slider');
  owlAbout.owlCarousel({
    loop: true,
    margin: 0,
    nav: false,
    items: 1
    // autoplay: true
    // autoplayTimeout: 3000
  });
  $('.about__slider__nav--left').on('click', function() {
    owlAbout.trigger('prev.owl.carousel');
  });
  $('.about__slider__nav--right').on('click', function() {
    owlAbout.trigger('next.owl.carousel');
  });

  const showHideItems = document.querySelectorAll('.about__showHide__para');
  if (showHideItems.length !== 0) {
    setTimeout(() => {
      showHide(showHideItems);
    }, 2000);
  }

  AOS.init();
});

$(window).resize(function() {
  AOS.refresh();
});

function showHide(items, active = 0) {
  let currentActive = active;

  items.forEach((item, index) => {
    if (index == currentActive) {
      item.classList.add('active');
    } else {
      item.classList.remove('active');
    }
  });
  if (items.length - 2 < currentActive) {
    currentActive = 0;
  } else {
    currentActive++;
  }

  setTimeout(() => {
    showHide(items, currentActive);
  }, 3000);
}

function new_map($el) {
  var $markers = $el.find('.marker');
  const lat = $markers.data('lat');
  const lng = $markers.data('lng');

  var args = {
    zoom: 13.6,
    center: new google.maps.LatLng(lat, lng),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    styles: [
      {
        featureType: 'administrative',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#444444'
          }
        ]
      },
      {
        featureType: 'landscape',
        elementType: 'all',
        stylers: [
          {
            color: '#f2f2f2'
          }
        ]
      },
      {
        featureType: 'poi',
        elementType: 'all',
        stylers: [
          {
            visibility: 'off'
          }
        ]
      },
      {
        featureType: 'road',
        elementType: 'all',
        stylers: [
          {
            saturation: -100
          },
          {
            lightness: 45
          }
        ]
      },
      {
        featureType: 'road.highway',
        elementType: 'all',
        stylers: [
          {
            visibility: 'simplified'
          }
        ]
      },
      {
        featureType: 'road.arterial',
        elementType: 'labels.icon',
        stylers: [
          {
            visibility: 'off'
          }
        ]
      },
      {
        featureType: 'transit',
        elementType: 'all',
        stylers: [
          {
            visibility: 'off'
          }
        ]
      },
      {
        featureType: 'water',
        elementType: 'all',
        stylers: [
          {
            color: '#46bcec'
          },
          {
            visibility: 'on'
          }
        ]
      }
    ]
  };

  // create map
  var map = new google.maps.Map($el[0], args);

  // add a markers reference
  map.markers = [];

  // add markers
  $markers.each(function() {
    add_marker($(this), map);
  });

  // center map
  // center_map(map);

  // return
  return map;
}

function add_marker($marker, map) {
  // var
  const icon = $('.contact__map__icon').html();
  var latlng = new google.maps.LatLng(
    $marker.attr('data-lat'),
    $marker.attr('data-lng')
  );

  // create marker
  var marker = new google.maps.Marker({
    position: latlng,
    map: map,
    icon: icon
  });

  // add to array
  map.markers.push(marker);

  // if marker contains HTML, add it to an infoWindow
  if ($marker.html()) {
    // create info window
    var infowindow = new google.maps.InfoWindow({
      content: $marker.html()
    });

    // show info window when marker is clicked
    google.maps.event.addListener(marker, 'click', function() {
      infowindow.open(map, marker);
    });
  }
}

function center_map(map) {
  // vars
  var bounds = new google.maps.LatLngBounds();

  // loop through all markers and create bounds
  $.each(map.markers, function(i, marker) {
    var latlng = new google.maps.LatLng(
      marker.position.lat(),
      marker.position.lng()
    );

    bounds.extend(latlng);
  });

  // only 1 marker?
  if (map.markers.length == 1) {
    // set center of map
    map.setCenter(bounds.getCenter());
    map.setZoom(16);
  } else {
    // fit to bounds
    map.fitBounds(bounds);
  }
}
